import React from "react";
import { Container } from "reactstrap";

const styles = {
  footer: {
    marginTop: "40px",
    padding: "0 12px 16px",
  },
  card: {
    borderRadius: "18px",
    border: "1px solid rgba(240,122,0,0.10)",
    background: "rgba(255,255,255,0.78)",
    padding: "16px 18px",
    boxShadow: "0 10px 24px rgba(84,44,14,0.05)",
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
  },
  copyWrap: {
    flex: "1 1 260px",
    textAlign: "center",
  },
  linksWrap: {
    flex: "1 1 260px",
    display: "flex",
    justifyContent: "center",
  },
  copy: {
    margin: 0,
    fontSize: "14px",
    fontWeight: 500,
    color: "#7a5a45",
  },
  links: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontSize: "14px",
  },
  link: {
    color: "#d96500",
    fontWeight: 700,
    textDecoration: "none",
  },
  dot: {
    color: "#c49a7b",
  },
};

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <Container fluid>
        <div style={styles.card}>
          <div style={styles.row}>
            <div style={styles.copyWrap}>
              <p style={styles.copy}>
                © 2026–2027 HireNeuron. All rights reserved.
              </p>
            </div>

            <div style={styles.linksWrap}>
              <div style={styles.links}>
                <a href="mailto:support@hireneuron.com" style={styles.link}>
                  support@hireneuron.com
                </a>

                <span style={styles.dot}>•</span>

                <a
                  href="https://hireneuron.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="as-privacy"
                  style={styles.link}
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
